var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMoreVert24Line = function SvgIconMoreVert24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 17.2a1.3 1.3 0 1 0-2.6 0 1.3 1.3 0 0 0 2.6 0ZM13.3 6.799a1.3 1.3 0 1 0-2.6 0 1.3 1.3 0 0 0 2.6 0ZM13.3 12a1.3 1.3 0 1 0-2.6 0 1.3 1.3 0 0 0 2.6 0Z",
    fill: "current"
  })));
};
export default SvgIconMoreVert24Line;